import type { CarouselItem, CarouselItemTyped } from '@setplex/tria-api'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { ShowWithPrice } from '~/shared/interfaces'

import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const formatFeaturedRowShows = (
  items: CarouselItem[],
  adjust: AdjustPurchaseableFn
): CarouselItemTyped<ShowWithPrice>[] => {
  return items.map((item: CarouselItem) => {
    return {
      ...item,
      tvShow:
        item.tvShow &&
        (extendMediaItemByLabelPrice(adjust(item.tvShow)) as ShowWithPrice),
    }
  })
}
